module.exports = __webpack_public_path__ + "img/legal_img.09bb2046.png";